import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";

function SalesVsExpense() {
  const navigate = useNavigate();
  const { date } = useParams();
  const [paymentModal, setPaymentModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [payments, setPayments] = useState([]);
  const [responseSalesData, setResponseSalesData] = useState([]);

  const openPaymentModal = () => setPaymentModal(true);
  const closePaymentModal = () => setPaymentModal(false);
  const openInfoModal = () => setInfoModal(true);
  const closeInfoModal = () => setInfoModal(false);

  const [addData, setAddData] = useState({
    l_s_repair_text: "",
    l_s_repair_value1: "",
    l_s_repair_value2: "",
    amount_in_cash: "",
    amount_staff: "",
    date: date,
    created_by: "",
    created_date: "",
  });

  useEffect(() => {
    fetchData();
  }, [date]);

  useEffect(() => {
    fetchSalesData();
  }, [date]); // re-fetch when date changes

  useEffect(() => {
    const totalAmount = payments
      .reduce((sum, payment) => sum + parseFloat(payment.paid_amount || 0), 0)
      .toFixed(2);
    setAddData((prev) => ({
      ...prev,
      amount_staff: totalAmount,
    }));
  }, [payments]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/sales_vs_expense.php`, {
        params: { date },
      });
      if (response.data.status && response.data.data) {
        const record = response.data.data.find((item) => item.date === date);
        if (record) {
          setResponseData(record);
          setPayments(record.payment_data || []);
          setAddData({
            l_s_repair_text: record.l_s_repair_text || "",
            l_s_repair_value1: record.l_s_repair_value1 || "",
            l_s_repair_value2: record.l_s_repair_value2 || "",
            amount_in_cash: record.amount_in_cash || "",
            amount_staff: record.amount_staff || "",
            date: record.date,
            created_by: record.created_by || "",
            created_date: record.created_date || "",
          });
        } else {
          setResponseData(null);
          setPayments([]);
          setAddData({
            l_s_repair_text: "",
            l_s_repair_value1: "",
            l_s_repair_value2: "",
            amount_in_cash: "",
            amount_staff: "",
            date: date,
            created_by: "",
            created_date: "",
          });
        }
      } else {
        setResponseData(null);
        setPayments([]);
        setAddData({
          l_s_repair_text: "",
          l_s_repair_value1: "",
          l_s_repair_value2: "",
          amount_in_cash: "",
          amount_staff: "",
          date: date,
          created_by: "",
          created_date: "",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseData(null);
      setPayments([]);
      setAddData({
        l_s_repair_text: "",
        l_s_repair_value1: "",
        l_s_repair_value2: "",
        amount_in_cash: "",
        amount_staff: "",
        date: date,
        created_by: "",
        created_date: "",
      });
    }
  };

  const fetchSalesData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/sales.php`);
      const allSales = response.data?.data || [];
      // Normalise to YYYY-MM-DD and compare with page date
      const filtered = allSales.filter((s) => {
        const raw = s.sales_date || "";
        const normalised = raw.includes("T") ? raw.split("T")[0] : raw.substring(0, 10);
        return normalised === date;
      });
      setResponseSalesData(filtered);
    } catch (error) {
      console.error("Error fetching sales data:", error.message);
      setResponseSalesData([]);
    }
  };

  const handleSubmitData = async () => {
    try {
      const {
        l_s_repair_text,
        l_s_repair_value1,
        l_s_repair_value2,
        amount_in_cash,
      } = addData;

      if (
        !l_s_repair_text &&
        !l_s_repair_value1 &&
        !l_s_repair_value2 &&
        !amount_in_cash
      ) {
        alert(
          "Please fill at least one of the fields: L.S. Repair Text, L.S. Repair Value 1, L.S. Repair Value 2, or Amount in Cash."
        );
        return;
      }

      const formData = {
        l_s_repair_text: l_s_repair_text || "",
        l_s_repair_value1: l_s_repair_value1 || "",
        l_s_repair_value2: l_s_repair_value2 || "",
        amount_in_cash: amount_in_cash || "",
        amount_staff: addData.amount_staff || "",
        date: date,
        created_by: addData.created_by || "",
        created_date: addData.created_date || new Date().toISOString(),
        updated_by: "",
        updated_date: new Date().toISOString(),
      };

      let response;
      // If no data exists for the date, use POST; otherwise, use PUT
      if (!responseData) {
        response = await axios.post(
          `${ApiUrl}/Api/sales_collection.php`,
          formData,
          { headers: { "Content-Type": "application/json" } }
        );
              navigate("/sales-vs-expense")
      } else {
        response = await axios.put(
          `${ApiUrl}/Api/sales_collection.php?date=${date}`,
          formData,
          { headers: { "Content-Type": "application/json" } }
 
        );
             navigate("/sales-vs-expense")
      }

      if (response.data.status) {
        alert(
          !responseData
            ? "Data created successfully!"
            : "Data updated successfully!"
        );
        fetchData();
      } else {
        throw new Error(response.data.message || "Failed to save data");
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      alert(`Error saving data: ${error.message}`);
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
        alert("Please select a payment type and enter a valid amount");
        return;
      }

      const paymentData = {
        date: date,
        pay_type: paymentType,
        paid_amount: parseFloat(paymentAmount).toFixed(2),
        created_by: "",
        created_date: new Date().toISOString(),
        updated_by: "",
        updated_date: "",
      };

      const response = await axios.post(
        `${ApiUrl}/Api/sales_vs_expense_payment.php`,
        paymentData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.status) {
        alert("Payment submitted successfully!");
        setPaymentAmount("");
        setPaymentType("");
        closePaymentModal();
        fetchData();
      } else {
        throw new Error(response.data.message || "Failed to submit payment");
      }
    } catch (error) {
      console.error("Error submitting payment:", error.message);
      alert(`Error submitting payment: ${error.message}`);
    }
  };

  const [showSalesTable, setShowSalesTable] = useState(false);
  const toggleSalesTable = () => setShowSalesTable(!showSalesTable);

  const [showPoSalesTable, setShowPoSalesTable] = useState(false);
  const togglePoSalesTable = () => setShowPoSalesTable(!showPoSalesTable);

  const [showOldSalesTable, setShowOldSalesTable] = useState(false);
  const toggleOldSalesTable = () => setShowOldSalesTable(!showOldSalesTable);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || isNaN(value)) return "0";
    return Number(value).toLocaleString("en-IN");
  };

  return (
    <div className="container-fluid pb-5">
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="container-fluid">
            <div
              className="card rounded-3 p-3"
              style={{ backgroundColor: "#D5F1F1" }}
            >
              <h4 className="text-center text-black border-0 mb-3">
                Transaction Overview - {formatDate(date)}
              </h4>
              <div className="row">
                <div className="col-lg-6">
                  <div className="card p-4">
                    <h6 className="text-primary mb-4">Sales</h6>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Sales</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">
                          ₹ {formatCurrency(responseData?.sales)}
                        </div>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={toggleSalesTable}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    {showSalesTable && (
                      <div className="mt-3">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales_No</th>
                                <th>Sales_Date</th>
                                <th>paid</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(() => {
                                const newSales = responseSalesData.filter((sale) => {
                                  const items = sale.item_list || [];
                                  // Show sale if it has at least one "New" action item, or has no items (header only)
                                  return items.some(
                                    (i) => (i.action_type || "").toLowerCase() === "new"
                                  ) || items.length === 0;
                                });
                                return newSales.length > 0 ? (
                                  newSales.map((item, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{item.sales_no || "-"}</td>
                                      <td>{formatDate(item.sales_date) || "-"}</td>
                                      <td>₹ {formatCurrency(item.paid)}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="4" className="text-center">
                                      No sales data available
                                    </td>
                                  </tr>
                                );
                              })()}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">PO Sales</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">
                          ₹ {formatCurrency(responseData?.po_sales)}
                        </div>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={togglePoSalesTable}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    {showPoSalesTable && (
                      <div className="mt-3">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales_No</th>
                                <th>Sales_Date</th>
                                <th>PO Sale</th>
                              </tr>
                            </thead>
                            <tbody>
                              {responseSalesData.length > 0 &&
                              responseSalesData.some(
                                (sale) => sale.item_list
                              ) ? (
                                responseSalesData.flatMap((sale, saleIndex) =>
                                  (sale.item_list || [])
                                    .filter(
                                      (item) =>
                                        item.action_type
                                          ?.trim()
                                          .toLowerCase() === "po-sale"
                                    )
                                    .map((item, index) => (
                                      <tr key={`${saleIndex}-${index}`}>
                                        <td>{saleIndex + 1}</td>
                                        <td>{sale.sales_no || "-"}</td>
                                        <td>
                                          {formatDate(sale.sales_date) || "-"}
                                        </td>
                                        <td>₹ {formatCurrency(item.amount)}</td>
                                      </tr>
                                    ))
                                ).length > 0 ? (
                                  responseSalesData.flatMap((sale, saleIndex) =>
                                    (sale.item_list || [])
                                      .filter(
                                        (item) =>
                                          item.action_type
                                            ?.trim()
                                            .toLowerCase() === "po-sale"
                                      )
                                      .map((item, index) => (
                                        <tr key={`${saleIndex}-${index}`}>
                                          <td>{saleIndex + 1}</td>
                                          <td>{sale.sales_no || "-"}</td>
                                          <td>
                                            {formatDate(sale.sales_date) || "-"}
                                          </td>
                                          <td>
                                            ₹ {formatCurrency(item.amount)}
                                          </td>
                                        </tr>
                                      ))
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="4" className="text-center">
                                      No PO sales data available
                                    </td>
                                  </tr>
                                )
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center">
                                    No PO sales data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Old Sales</span>
                      <div className="d-flex gap-2">
                        <div className="bg-light rounded px-3 py-2 text-end">
                          ₹ {formatCurrency(responseData?.old_sales)}
                        </div>
                        <button
                          className="btn btn-sm btn-success"
                          onClick={toggleOldSalesTable}
                        >
                          <i className="fa-solid fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    {showOldSalesTable && (
                      <div className="mt-3">
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales_No</th>
                                <th>Sales_Date</th>
                                <th>Old Sales</th>
                              </tr>
                            </thead>
                            <tbody>
                              {responseSalesData.length > 0 &&
                              responseSalesData.some(
                                (sale) => sale.item_list
                              ) ? (
                                responseSalesData.flatMap((sale, saleIndex) =>
                                  (sale.item_list || [])
                                    .filter(
                                      (item) =>
                                        item.action_type
                                          ?.trim()
                                          .toLowerCase() === "old sales"
                                    )
                                    .map((item, index) => (
                                      <tr key={`${saleIndex}-${index}`}>
                                        <td>{saleIndex + 1}</td>
                                        <td>{sale.sales_no || "-"}</td>
                                        <td>
                                          {formatDate(sale.sales_date) || "-"}
                                        </td>
                                        <td>₹ {formatCurrency(item.amount)}</td>
                                      </tr>
                                    ))
                                ).length > 0 ? (
                                  responseSalesData.flatMap((sale, saleIndex) =>
                                    (sale.item_list || [])
                                      .filter(
                                        (item) =>
                                          item.action_type
                                            ?.trim()
                                            .toLowerCase() === "old sales"
                                      )
                                      .map((item, index) => (
                                        <tr key={`${saleIndex}-${index}`}>
                                          <td>{saleIndex + 1}</td>
                                          <td>{sale.sales_no || "-"}</td>
                                          <td>
                                            {formatDate(sale.sales_date) || "-"}
                                          </td>
                                          <td>
                                            ₹ {formatCurrency(item.amount)}
                                          </td>
                                        </tr>
                                      ))
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan="4" className="text-center">
                                      No old sales data available
                                    </td>
                                  </tr>
                                )
                              ) : (
                                <tr>
                                  <td colSpan="4" className="text-center">
                                    No old sales data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Sales Balance</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.sales_balance)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Retailer Balance</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.retailer_balance)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Order Advance</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.order_advance)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Order Complete</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.order_complete)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">L.S. Repair</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Value"
                        value={addData.l_s_repair_value1}
                        onChange={(e) =>
                          setAddData({
                            ...addData,
                            l_s_repair_value1: e.target.value,
                          })
                        }
                        style={{ width: "180px" }}
                      />
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Text"
                        value={addData.l_s_repair_text}
                        onChange={(e) =>
                          setAddData({
                            ...addData,
                            l_s_repair_text: e.target.value,
                          })
                        }
                        style={{ width: "180px" }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Value"
                        value={addData.l_s_repair_value2}
                        onChange={(e) =>
                          setAddData({
                            ...addData,
                            l_s_repair_value2: e.target.value,
                          })
                        }
                        style={{ width: "180px" }}
                      />
                    </div>
                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Total</span>
                      <div
                        className="border rounded px-3 py-1 text-end"
                        style={{ width: "180px" }}
                      >
                        ₹ {formatCurrency(responseData?.sales_total)}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="card h-100 p-3">
                    <h6 className="text-primary mb-4">Expense</h6>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Exchange</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.exchange)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">G Pay</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.gpay)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Expense</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.expense)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Loan Closed List</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.loan_closed_list)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Chit Closed List</span>
                      <div className="bg-light rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.chit_closed_list)}
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <div>
                        <span className="fw-bold">Amount</span>
                        <br />
                        <span className="small">
                          Staff <i className="fa-solid fa-arrow-right"></i>{" "}
                          Manager
                        </span>
                      </div>
                      <div
                        className="d-flex align-items-center"
                        style={{ width: "250px" }}
                      >
                        <input
                          type="text"
                          className="form-control mt-3"
                          placeholder="Amount"
                          value={addData.amount_staff}
                          disabled
                        />
                        <button
                          className="btn btn-success ms-2"
                          onClick={openPaymentModal}
                        >
                          +
                        </button>
                        <button
                          className="btn btn-light ms-1 border"
                          onClick={openInfoModal}
                        >
                          <i className="bi bi-info-circle"></i>
                        </button>
                      </div>
                    </div>
                    <div className="mb-1 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Amount in Cash</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Amount"
                        value={addData.amount_in_cash}
                        onChange={(e) =>
                          setAddData({
                            ...addData,
                            amount_in_cash: e.target.value,
                          })
                        }
                        style={{ width: "180px" }}
                      />
                    </div>
                    <div className="mt-3 d-flex justify-content-between align-items-center">
                      <span className="fw-bold">Total</span>
                      <div className="border rounded px-3 py-2 text-end">
                        ₹ {formatCurrency(responseData?.expense_total)}
                      </div>
                    </div>
                    <div className="row mt-5">
                      <div className="col-lg-8"></div>
                      <div className="col-lg-4">
                        <div className="d-flex">
                          <button
                            className="btn btn-sm btn-secondary mx-2"
                            onClick={() => navigate("/sales-vs-expense")}
                          >
                            Back
                          </button>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleSubmitData}
                          >
                            {responseData ? "Update" : "Save"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`modal fade ${paymentModal ? "show" : ""}`}
            style={{ display: paymentModal ? "block" : "none" }}
            tabIndex="-1"
            aria-labelledby="addPaymentModalLabel"
            aria-hidden={!paymentModal}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h6
                    className="modal-title text-primary"
                    id="addPaymentModalLabel"
                  >
                    Add Payment
                  </h6>
                  <button
                    type="button"
                    className="btn-close"
                    style={{ fontSize: "10px" }}
                    onClick={closePaymentModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <form onSubmit={handlePaymentSubmit}>
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="mb-3">
                          <label>Pay Type</label>
                          <select
                            className="form-select"
                            value={paymentType}
                            onChange={(e) => setPaymentType(e.target.value)}
                          >
                            <option value="">Select Paytype</option>
                            <option value="cash">Cash</option>
                            <option value="gpay">Gpay</option>
                            <option value="phonepe">Phonepe</option>
                            <option value="paytm">Paytm</option>
                            <option value="credit">Credit</option>
                            <option value="debit">Debit</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="mb-3">
                          <label>Enter Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Amount"
                            value={paymentAmount}
                            onChange={(e) => setPaymentAmount(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm mt-4"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`modal fade ${infoModal ? "show" : ""}`}
            style={{ display: infoModal ? "block" : "none" }}
            tabIndex="-1"
            aria-labelledby="paymentHistoryModalLabel"
            aria-hidden={!infoModal}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h6
                    className="modal-title text-primary"
                    id="paymentHistoryModalLabel"
                  >
                    Payment History - {formatDate(date)}
                  </h6>
                  <button
                    type="button"
                    className="btn-close"
                    style={{ fontSize: "10px" }}
                    onClick={closeInfoModal}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div
                    className="card"
                    style={{
                      borderRadius: "15px",
                      backgroundColor: "#5c9dff",
                      color: "white",
                    }}
                  >
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table text-white">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Date</th>
                              <th>Pay Type</th>
                              <th>Paid Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {payments.length > 0 ? (
                              payments.map((payment, index) => (
                                <tr key={payment.id || index}>
                                  <td>{index + 1}</td>
                                  <td>{formatDate(payment.date)}</td>
                                  <td>{payment.pay_type}</td>
                                  <td>
                                    ₹ {formatCurrency(payment.paid_amount)}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center">
                                  No payment history available for{" "}
                                  {formatDate(date)}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {(paymentModal || infoModal) && (
            <div
              className="modal-backdrop fade show"
              onClick={() => {
                closePaymentModal();
                closeInfoModal();
              }}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SalesVsExpense;